import { captureException } from '@sentry/browser';

import {
  addToDataLayer,
  getCategories,
  type TrackingEventItem,
  useTracking,
} from '@/composables/tracking';

import { useFischer } from './fischerPlugin';

export const useTrackViewItem = () => {
  const { enableTracking, getPriceForTracking } = useTracking();
  const fischer = useFischer();

  const trackViewItem = async (data: any, isFamily: boolean): Promise<void> => {
    try {
      if (!enableTracking()) {
        return;
      }

      const ecomLang = isFamily
        ? data.TextList.find((el: any) => el.Key === 'BEZEICHNUNG')?.Value ||
          data.TextList.find((el: any) => el.Key === 'ARTIKELLANG')?.Value
        : data.TextList.find((el: any) => el.Key === 'ECOMLANG')?.Value;
      const itemId = isFamily ? data.CategoryId || data.Number : data.ProductId;

      const item: TrackingEventItem = {
        item_name: ecomLang,
        item_id: itemId,
        item_brand: fischer.brandName(),
        ...getCategories(data.CategoryDisplayNamePath),
      };

      if (!isFamily) {
        item.item_variant = data.ProductName;
      }

      // No unit: the view price is always the backend's own default.
      const { price, quantity, currency, totalPrice } = await getPriceForTracking(
        data.ProductId,
        0,
      );
      if (price) {
        item.price = price;
        item.quantity = quantity;
      }

      let ecommerce;
      if (totalPrice) {
        ecommerce = {
          currency: currency,
          value: totalPrice,
        };
      }

      addToDataLayer('view_item', [item], ecommerce);
    } catch (error) {
      console.error(error);
      captureException(error);
    }
  };

  return { trackViewItem };
};
